import type { ReactNode } from 'react';
import './context-field.css';

export function CtxGrid({ children }: { children: ReactNode }) {
  return <div className="ctxf-grid">{children}</div>;
}

export function CtxSubhead({ children }: { children: ReactNode }) {
  return <div className="ctxf-subhead">{children}</div>;
}

export function CtxField({
  label,
  value,
  placeholder,
  full,
}: {
  label: string;
  value?: string;
  placeholder?: string;
  full?: boolean;
}) {
  const filled = !!value && value.trim() !== '';
  return (
    <div className={`ctxf-field${full ? ' full' : ''}`}>
      <div className="ctxf-label">{label}</div>
      <div className={`ctxf-value${filled ? '' : ' empty'}`}>
        {filled ? value : (placeholder ?? 'Not yet captured')}
      </div>
    </div>
  );
}
